import { render, staticRenderFns } from "./EdInputMoney.vue?vue&type=template&id=359009d0&"
import script from "./EdInputMoney.vue?vue&type=script&lang=js&"
export * from "./EdInputMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports